<template>
  <BubbleMenu v-if="editor" :editor="editor" :tippy-options="tippyOptions">
    <div class="relative bubble-menu bg-white">
      <slot></slot>
    </div>
  </BubbleMenu>
</template>
<script lang="ts" setup>
import { computed, PropType } from 'vue';
import { BubbleMenu } from '@tiptap/vue-3';
import type { Editor } from '@tiptap/vue-3';
const props = defineProps({
  editor: {
    type: Object as PropType<Editor>,
    required: true,
  },
  isModal: {
    type: Boolean,
    default: false,
  },
  zoom: {
    type: Number,
    default: 100,
  },
});
const emit = defineEmits(['close']);
function getReferenceClientRect(editor: HTMLElement): () => DOMRect {
  return () => {
    const selection = window.getSelection();
    if (!selection?.rangeCount) return new DOMRect();
    const range = selection.getRangeAt(0);
    const rect = range.getBoundingClientRect();
    const zoomFactor = props.zoom / 100;
    const scaledRect = {
      width: rect.width / zoomFactor,
      height: rect.height / zoomFactor,
      top: rect.top / zoomFactor,
      bottom: rect.bottom / zoomFactor,
      left: rect.left / zoomFactor,
      right: rect.right / zoomFactor,
      x: rect.x / zoomFactor,
      y: rect.y / zoomFactor,
      toJSON: () => {}, // dummy for compatibility
    };
    return scaledRect as DOMRect;
  };
}
const tippyOptions = computed(() => ({
  //@ts-ignore
  getReferenceClientRect: getReferenceClientRect(
    props.editor as unknown as HTMLElement,
  ),
  appendTo: document.querySelector('.page') ?? document.body,
  zIndex: 999999999,
}));
</script>
<style scoped>
.bubble-menu {
  @apply flex justify-center items-center bg-white border border-secondary-100 bg-white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  z-index: 9999;
  padding-top: 4px;
}
</style>
